import { ActivatedRoute } from '@angular/router';
// import { BaseComponent } from '@tcm-modules/tcm-core.module';
import { SecureBaseComponentContext } from '../services/secure-base-component-context.service';
import { PermissionsConsumer } from '../../../components/permissions-consumer';
import { PermissionsInfo } from '../../../components/permissions-info';
import { Subscription } from 'rxjs/internal/Subscription';
import { EntityPermissionNode, RoleAccessSettings, AreaEntityNode, EntityAccesses } from '../../../models/roles';
import { Directive } from "@angular/core";
import { BaseComponent } from '../../tcm-core.module/components/base-component/base-component.component';


@Directive()
export abstract class TcmSecureBaseComponent<TRequest, TViewModel> extends BaseComponent<TRequest, TViewModel> implements PermissionsConsumer {

    set permissionsInfo(permissionsInfo: PermissionsInfo) {
        if (!this._permissionsInfo) {
            this._permissionsInfo = permissionsInfo;
            this.setPermissionsInfo();
        }
    }

    get canRead() {
        return this._entityPermissions && this._entityPermissions.canRead;
    }

    get canEdit() {
        return this._entityPermissions && this._entityPermissions.canEdit;
    }

    private _entityPermissions: EntityPermissionNode;
    private _permissionsInfo: PermissionsInfo;
    private permissionsSubscription: Subscription;

    private currentPermissions: RoleAccessSettings;

    constructor(protected override componentContext: SecureBaseComponentContext, protected override route: ActivatedRoute) {
        super(componentContext, route);
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();
    }

    override ngOnDestroy() {
        super.ngOnDestroy();

        if (this.permissionsSubscription) {
            this.permissionsSubscription.unsubscribe();
        }
    }

    protected onPermissionChanged() {

    }

    private setPermissionsInfo() {
        
        if (this._permissionsInfo) {

            this.permissionsSubscription = this.componentContext.permissionService.permissions$.subscribe(x => {
                if (!x)
                    return;

                this.currentPermissions = x;

                const mainEntityPermissions = this.getEntityNode(this._permissionsInfo);

                if (mainEntityPermissions && mainEntityPermissions.canRead !== true && this.isRootComponent === true) {

                    this.goBack();

                    return;
                }

                this._entityPermissions = mainEntityPermissions;

                this.onPermissionChanged();
            });
        }
    }

    protected getEntityNode(permissionInfo: PermissionsInfo): EntityPermissionNode {
        const areaNode: AreaEntityNode = this.currentPermissions.entities[permissionInfo.areaPermissionKey];

        if (!areaNode)
            return null;

        const entityNode: EntityPermissionNode = areaNode[permissionInfo.entityPermissionKey];

        return entityNode;
    }

    protected canReadNode<T extends EntityAccesses, K1 extends keyof T, K2 extends keyof T[K1]>(a: K1, b: K2): boolean {
        const permissionInfo = { areaPermissionKey: a as string, entityPermissionKey: b as string };

        const node = this.getEntityNode(permissionInfo);

        return node && node.canRead === true;
    }

    protected canEditNode<T extends EntityAccesses, K1 extends keyof T, K2 extends keyof T[K1]>(a: K1, b: K2): boolean {
        const permissionInfo = { areaPermissionKey: a as string, entityPermissionKey: b as string };

        const node = this.getEntityNode(permissionInfo);

        return node && node.canEdit === true;
    }
}